import { render, staticRenderFns } from "./AddNewReport.vue?vue&type=template&id=21ba43fc&"
import script from "./AddNewReport.vue?vue&type=script&lang=js&"
export * from "./AddNewReport.vue?vue&type=script&lang=js&"
import style0 from "./AddNewReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports